import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { toast } from 'sonner';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    navigate('/admin/dashboard', { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Innlogget');
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      toast.error(err.message || 'Feil ved innlogging');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex">
      {/* Left brand panel */}
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0" style={{ background: 'radial-gradient(60% 50% at 50% 40%, rgba(204,255,0,0.06) 0%, transparent 70%)' }} />
        <div className="relative z-10 text-center px-12">
          <h1 className="font-['Barlow_Condensed'] font-bold text-7xl text-white tracking-wider mb-4">TEMPO</h1>
          <div className="w-12 h-[2px] bg-[#CCFF00] mx-auto mb-4" />
          <p className="text-sm text-white/40 tracking-[0.18em] uppercase">Admin Portal</p>
        </div>
      </div>
      {/* Right login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden text-center mb-10">
            <h1 className="font-['Barlow_Condensed'] font-bold text-4xl text-white tracking-wider">TEMPO</h1>
            <p className="text-xs text-white/40 tracking-[0.18em] uppercase mt-2">Admin Portal</p>
          </div>
          <div className="rounded-[16px] bg-[rgba(255,255,255,0.03)] border border-white/5 p-8 sm:p-10">
            <h2 className="font-['Barlow_Condensed'] font-bold text-2xl text-white mb-1">Logg inn</h2>
            <p className="text-sm text-white/40 mb-8">Bruk admin-legitimasjonen din for å fortsette.</p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="uppercase tracking-[0.18em] text-[11px] font-medium text-white/55 mb-2 block">E-post</label>
                <input
                  data-testid="admin-login-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@tempo.app"
                  required
                  className="w-full h-[52px] rounded-[14px] bg-[#121212] border border-white/10 text-white px-4 placeholder:text-white/20 focus:outline-none focus:ring-2 focus:ring-[#CCFF00]/35 transition-[box-shadow] duration-180"
                />
              </div>
              <div>
                <label className="uppercase tracking-[0.18em] text-[11px] font-medium text-white/55 mb-2 block">Passord</label>
                <input
                  data-testid="admin-login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  className="w-full h-[52px] rounded-[14px] bg-[#121212] border border-white/10 text-white px-4 placeholder:text-white/20 focus:outline-none focus:ring-2 focus:ring-[#CCFF00]/35 transition-[box-shadow] duration-180"
                />
              </div>
              <button
                data-testid="admin-login-submit-button"
                type="submit"
                disabled={loading}
                className="w-full h-[58px] rounded-[16px] bg-[#CCFF00] text-black font-semibold text-base hover:bg-[#D7FF3A] hover:shadow-[0_14px_48px_rgba(204,255,0,0.16)] active:scale-[0.99] transition-[background-color,box-shadow,transform] duration-180 shadow-[0_12px_40px_rgba(204,255,0,0.12)] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <span className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />
                    Logger inn...
                  </span>
                ) : 'Logg inn'}
              </button>
            </form>
          </div>
          <p className="text-center text-xs text-white/20 mt-6">
            <a href="/" className="hover:text-white/40 transition-colors duration-180">← Tilbake til Tempo</a>
          </p>
        </div>
      </div>
    </div>
  );
}
